(() => {
  var BDTabContainerApp = (() => {
    var open = (container, data_symbol, data_index) => {
      if (!container || data_index === '') return;
      container.querySelectorAll('[js-tab-header], [js-tab-body]').forEach(element => {
        if (element.getAttribute('data-symbol') == data_symbol) {
          element.classList.remove('active');
          if (element.getAttribute('data-index') === data_index) {
            element.classList.add('active');
          }
        }
      });
    }
    var initialize = () => {
      document.querySelectorAll('[js-tab-container] [js-tab-header]').forEach(element => {
        element.addEventListener('click', () => {
          open(element.closest('[js-tab-container]'), element.getAttribute('data-symbol'), element.getAttribute('data-index'));
        });
      });
    }
    return {
      init: initialize
    }
  })();
  
	
  var FAQApp = (() => {
    var close = (block) => {
      if (!block) return;
      block.classList.remove('open');
    }
    var open = (block) => {
      if (!block) return;
      const container = block.closest('[js-faq]');
      if (container) {
        container.querySelectorAll('[js-faq-block]').forEach(element => {
          close(element);
        });
      }
      block.classList.add('open');
    }
    var initialize = () => {
      document.querySelectorAll('[js-faq] [js-faq-block] [js-question]').forEach(element => {
        element.addEventListener('click', () => {
          if (element.closest('[js-faq-block]').classList.contains('open')) {
            close(element.closest('[js-faq-block]'));
          } else {
            open(element.closest('[js-faq-block]'));
          }
        });
      });
    }
    return {
      init: initialize
    }
  })();

  let variantPickerApp = (() => {
    let initialize = () => {
      const variantElements = document.querySelectorAll('.thumbnail-swatch');
      variantElements.forEach((ele) => {
        ele.addEventListener("click", () => {
          const inputID = ele.getAttribute("for");
          let colorValue = '';
          if (inputID) {
            colorValue = document.getElementById(inputID).value;
            console.log("This is the color value", colorValue);
          }
          document.querySelectorAll(".pi-image-gallery-carousel .variant-color-image").forEach((image) => {
            if (image.dataset.colorValue == colorValue) {
              image.classList.add("active");
            } else {
              image.classList.remove("active");
            }
          });
          document.querySelectorAll(".pi-image-gallery-carousel-nav .variant-color-image").forEach((image) => {
            if (image.dataset.colorValue == colorValue) {
              image.classList.add("active");
            } else {
              image.classList.remove("active");
            }
          });

          variantElements.forEach((element) => {
            element.classList.remove("active");
          });
          ele.classList.add("active");
        });
      });
    }
    return {
      init: initialize
    }
  })();

  var pdpAsLandingSliderApp = (() => {
    var initialize = () => {
      const mainSlider = new Flickity('#pi-image-gallery-main', {
				initialIndex: 1,
        draggable: true,
        prevNextButtons: false,
        adaptiveHeight: false,
        wrapAround: false,
        pageDots: false,
        contain: false,
        imagesLoaded: true,
        cellAlign: 'left',
        percentPosition: false
      });
      const navSlider = new Flickity('#pi-image-gallery-nav', {
				initialIndex: 1,
        draggable: true,
        prevNextButtons: false,
        adaptiveHeight: false,
        wrapAround: false,
        pageDots: false,
        contain: false,
        imagesLoaded: true,
        asNavFor: '#pi-image-gallery-main',
        cellAlign: 'left',
        percentPosition: false
      });

      // Sync thumbnail highlight
      mainSlider.on('select', () => {
        document.querySelectorAll('.image_wrapper--thumb').forEach((thumb, i) => {
          thumb.classList.toggle('is-selected', i === mainSlider.selectedIndex);
        });
      });

      // On variant/color change — swap only slot 1 & 2
      function updateVariantImages(variantId) {
        console.log('1. variantId received:', variantId);
        console.log('2. window.variantImages:', window.variantImages);
        const data = window.variantImages[variantId];
        if (!data) return;
        console.log('4. image1 url:', data.image1);  

        // Update main slider slides
        [1].forEach(slot => {
          const slides = document.querySelectorAll(
            `.pi-image-gallery-variant[data-slot="${slot}"]`
          );
          console.log(`6. slides found for slot ${slot}:`, slides.length);

          slides.forEach(slide => {
            let img = slide.querySelector('img');
            if (!img) {
              console.log(`7. slides found for slot ${slot}:`, slides.length);
              img = document.createElement('img');
              slide.appendChild(img);
            }
            const imgSrc = slot === 1 ? data.image1 : data.image2;
            
            setTimeout(() => {
              img.removeAttribute('nsfwimgid');
              img.removeAttribute('nsfwstatus');
              img.removeAttribute('nsfworiginalSrc');
              img.removeAttribute('srcset');
              img.removeAttribute('data-src');
              img.removeAttribute('data-srcset');

              img.src = imgSrc;

              img.onload = () => {
                mainSlider.reloadCells();
                navSlider.reloadCells();
                mainSlider.resize();
                navSlider.resize();
                mainSlider.select(0, false, true);
              };
            }, 100);
          });
        });

        // Update thumbnails
        [1].forEach(slot => {
          const thumb = document.querySelector(
            `.pi-image-gallery-thumb-variant[data-slot="${slot}"]`
          );
          if (thumb) {
            // const img = thumb.querySelector('img') || document.createElement('img');
            // img.src = slot === 1 ? data.thumb1 : data.thumb2;
            // if (!thumb.querySelector('img')) thumb.appendChild(img);
            
            let img = thumb.querySelector('img');
            if (!img) {
              img = document.createElement('img');
              thumb.appendChild(img);
            }
            const imgSrc = slot === 1 ? data.thumb1 : data.thumb2;
            
            setTimeout(() => {
              img.removeAttribute('nsfwimgid');
              img.removeAttribute('nsfwstatus');
              img.removeAttribute('nsfworiginalSrc');
              img.removeAttribute('srcset');
              img.removeAttribute('data-src');
              img.removeAttribute('data-srcset');

              img.src = imgSrc;

              img.onload = () => {
                mainSlider.reloadCells();
                navSlider.reloadCells();
                mainSlider.resize();
                navSlider.resize();
                mainSlider.select(0, false, true);
              };
            }, 100);
          }
        });

        // Resize Flickity after image swap
        // setTimeout(() => {
        //   mainSlider.reloadCells();
        //   navSlider.reloadCells();
        //   mainSlider.select(0, false, true);
        // }, 150);
        // mainSlider.reloadCells();
        // navSlider.reloadCells();
        mainSlider.resize();
        navSlider.resize();

        // Jump back to slide 1
        // mainSlider.select(0, false, true);
      }

      // Hook into variant change — adjust selector to match your swatch markup
      document.querySelectorAll('[data-variant-id]').forEach(swatch => {
        swatch.addEventListener('click', () => {
          updateVariantImages(swatch.dataset.variantId);
        });
      });

      // Also listen to Shopify's native variant change event
      document.addEventListener('variant:changed', (e) => {
        if (e.detail?.variant?.id) {
          updateVariantImages(e.detail.variant.id);
        }
      });
      
      const variantElements = document.querySelectorAll('.thumbnail-swatch');
      variantElements.forEach((ele) => {
        ele.addEventListener("click", () => {
          const inputID = ele.getAttribute("for");
          let colorValue = '';
          if (inputID) {
            colorValue = document.getElementById(inputID).value;
            console.log("This is the color value", colorValue);
          }
          
          console.log("This is the color value for slider", colorValue);
          // Find matching variant
          const matchedVariant = window.__productVariants.find(variant =>
            variant.options.includes(colorValue)
          );

          if (matchedVariant) {
            console.log("Here are matched color", matchedVariant.options);
            updateVariantImages(matchedVariant.id);
          }
        });
      });
      // document
      //   .querySelectorAll('[js-product-gallery-slider]')
      //   .forEach(element => {
      //     new Flickity(element, {
      //       prevNextButtons: false,
      //       adaptiveHeight: false,
      //       wrapAround: false,
      //       pageDots: false,
      //       contain: true,
      //       imagesLoaded: true,
      //       cellAlign: 'center',
      //       on: {
      //         ready: function() {
      //           this.select(1);
      //         }
      //       }
      //     })
      //   })
    }
    return {
      init: initialize
    }
  })();

  
	let popupInitApp = (() => {
		let initialize = () => {
			var overlay = document.getElementById('pdp-group-buy-popup-overlay');
			var closeBtn = document.querySelector('#pdp-group-buy-popup-overlay .gbpo-close');

			if (overlay) {
				var open = () => {
					overlay.classList.add('is-open');
					overlay.setAttribute('aria-hidden', 'false');
				}

				var close = () => {
					// console.log('close event')
					overlay.classList.remove('is-open')
					overlay.setAttribute('aria-hidden', 'true')
				}

				// Open on button click
				document.querySelectorAll('.gbpo-popup-button').forEach(element => {
					element.addEventListener('click', e => {
						e.preventDefault();
						open();
					})
				})

				// Close on close button click
				if (closeBtn) {
					closeBtn.addEventListener('click', close);
				}

				// Close on overlay background click
				overlay.addEventListener('click', e => {
					// console.log('close event', overlay, e.target);

					// if (e.target === overlay) close();
					if (e.target.classList.contains('mask') && e.target.classList.contains('close')) close();
				})

				// Close on Escape key
				document.addEventListener('keydown', e => {
					if (e.key === 'Escape') close();
				})
			}
		}
		return {
			init: initialize
		}
	})();
	
	let popupTreateApp = (() => {
		let initialize = () => {
			const minusBtn   = document.querySelector('.gbpo-quantity-selector-btn-minus');
			const plusBtn    = document.querySelector('.gbpo-quantity-selector-btn-plus');
			const valueEl    = document.querySelector('.gbpo-quantity-selector-value');
			const slider     = document.querySelector('.gbpo-quantity-selector-slider');
			const dots   = document.querySelectorAll('.gbpo-quantity-slider-dot');
			const discountTextEle = document.querySelector(".gbpo-quantity-selector-note");
			const discountedPriceEle = document.querySelector(".gbpo-quantity-selector-discount-price");
			// limited quantity offer
			const limitedQuantityOfferEle = document.querySelector(".gbpo-limited-quantity-offer");
			const limitedQuantityEle = document.querySelector(".gbpo-limited-quantity");
			const limitedQuantityResultPriceEle = document.querySelector(".gbpo-limited-quantity-result-price");

			// const MIN = parseInt(slider.min) || 10;
			const MIN = 1;
			// const MAX = parseInt(slider.max) || 500;
			const MAX = 500;
			const dotValues = [1];
			let segments = dots.length; // number of the space between quantity base value(10, 20, 50, 100, 150...)
			let unitPerSegment = 100;
			let sliderMax = unitPerSegment * segments;

			dots.forEach((dot) => {
				if (dot.dataset.value) {
					dotValues.push(Number(dot.dataset.value));
				}
			})

			const inputEle = document.getElementById("gbpo-input");
			const totalPriceEle = document.querySelector('.gppo-total-price');
			const totalPriceValueEle = document.querySelector('.gppo-total-price-value-container');
			const QuantitySelectorEle = document.querySelector('.pi-quantity-selector-text');
			const quantityItems = document.querySelectorAll('.gbpo-quantity');
			const addToCartButtonEle = document.querySelector('.gbpo-button');
			const subtotalPriceLabel = document.querySelector('.pi-subtotal-value');
			const unitPriceLabel = document.querySelector('.pi-unit-price-value');
			const variantPickerEle = document.querySelector('variant-picker');
			const addToCartButtonEle1 = document.querySelector('.pi-cta-button');
			let selectedQuantity = 10;
			let leftQuantity = 0; // left quantity to reach new price
			let enablePriceToReach = 0; // enable price to reach

			if (!quantityItems) return;
			quantityItems.forEach(ele => {
				ele.addEventListener("click", () => {
					quantityItems.forEach((element => {
						element.classList.remove("active");
					}));
					ele.classList.add("active");

					selectedQuantity = ele.querySelector('.gbpo-quantity-label')?.innerText;
					if (selectedQuantity) {
						selectedQuantity = selectedQuantity.replace(" Tassen", '');
						updateUI(selectedQuantity); 
					}

					let selectedPrice = ele.querySelector('.gbpo-quantity-price')?.getAttribute('data-price');
					if (selectedPrice) {
						selectedPrice = selectedPrice.replace("€", "");
					}

					let totalPrice = 0;
					if (selectedQuantity && selectedPrice) {
						totalPrice = (Number(selectedQuantity) * Number(selectedPrice)).toFixed(2);
					}

					// let currency_unit = window.formatMoney(totalPrice);
					if (totalPriceValueEle && subtotalPriceLabel && unitPriceLabel) {
						totalPriceValueEle.innerHTML = `${totalPrice}€`;

						console.log("These are the total price and the selected price......", totalPrice, selectedPrice);
						if (Number(selectedQuantity) > 1) {
							subtotalPriceLabel.innerHTML = `${totalPrice}€`;
						} else {
							subtotalPriceLabel.innerHTML = `ab ${totalPrice}€`;
						}
						unitPriceLabel.innerHTML = `ab ${selectedPrice}€ p.S`;
					}

					if (!inputEle) return;
					inputEle.value = selectedQuantity;
					totalPriceEle.classList.add("active");

					if (!QuantitySelectorEle) return;
					QuantitySelectorEle.innerHTML = selectedQuantity;

					addToCartButtonEle.classList.add("active");
				});
			})

			if (inputEle && totalPriceValueEle) {
				inputEle.addEventListener("change", (e) => {
					const priceElements = document.querySelectorAll(".gbpo-quantity");
					selectedQuantity = inputEle.value;
					if (Number(selectedQuantity) == 0) {
						totalPriceEle.classList.remove("active");
						addToCartButtonEle.classList.remove("active");
						discountTextEle.classList.remove("active");
						limitedQuantityOfferEle.classList.remove("active");

						return;
					}

					let compareAtPriceUnit = 0;
					let compareAtPrice = 0;
					let discountedPrice = 0;
					let minQuantity = 0;
					let selectedPrice = 0;

					console.log("This is the selected quantity", selectedQuantity);
					for (let i = 0; i < priceElements.length; i ++) {
						let quantity = priceElements[i].querySelector('.gbpo-quantity-label')?.textContent?.trim();
						console.log("This is the quantity label", priceElements[i].querySelector('.gbpo-quantity-label').innerHMTL);
						let priceEle = priceElements[i].querySelector('.gbpo-quantity-price');
						if (!priceEle) continue;

						let price = priceEle.getAttribute("data-price");
						if (quantity && price) {
							quantity = quantity.replace(" Tassen", '');
							console.log("Here is the quantity.....0", quantity, parseInt(quantity), Number(quantity));
							price = price.replace("€", "");
						}
						console.log("Here is the quantity.....1", quantity, parseInt(quantity), Number(quantity));

						if (i == 0) {
							selectedPrice = parseFloat(price);
							minQuantity = Number(quantity);

							compareAtPriceUnit = parseFloat(price);
						}
						if (Number(selectedQuantity) >= minQuantity && Number(selectedQuantity) >= Number(quantity)) {
							console.log("This is the selectedQuantity and quantity", parseInt(selectedQuantity), parseInt(quantity), Number(quantity));
							selectedPrice = parseFloat(price);
							minQuantity = Number(quantity);

							// clear the active class of all quantity selector(button)
							priceElements.forEach((element => {
								element.classList.remove("active");
							}));
							priceElements[i].classList.add("active");

							if (i == priceElements.length - 1 && Number(selectedQuantity) == Number(quantity)) {
								leftQuantity = 0; // left quantity to reach new price
								enablePriceToReach = parseFloat(price); // enable price to reach
							}
						} else if (Number(selectedQuantity) >= minQuantity && Number(selectedQuantity) < Number(quantity)) {
							// console.log("This is the selected quantity and current quantity", selectedQuantity, quantity);
							leftQuantity = Number(quantity) - Number(selectedQuantity); // left quantity to reach new price
							enablePriceToReach = parseFloat(price); // enable price to reach

							break;
						} else if (Number(selectedQuantity) < minQuantity ) {//deal extra case like the quantity is smaller than first value(10)
							let nextQuantity = priceElements[1].querySelector('.gbpo-quantity-label')?.innerText;
							let nextPriceEle = priceElements[1].querySelector('.gbpo-quantity-price');
							if (!nextPriceEle) continue;

							let nextPrice = nextPriceEle.getAttribute("data-price");
							if (nextQuantity && nextPrice) {
								nextQuantity = nextQuantity.replace(" Tassen", '');
								nextPrice = nextPrice.replace("€", "");
							}

							leftQuantity = Number(nextQuantity) - Number(selectedQuantity); // left nextQuantity to reach new nextPrice
							enablePriceToReach = Number(nextPrice); // enable nextPrice to reach
							// console.log("This is the selected quantity and current quantity", selectedQuantity, nextQuantity);

							break;
						}
					};

					let totalPrice = 0;
					totalPriceEle.classList.add("active");
					totalPrice = (Number(selectedQuantity) * Number(selectedPrice)).toFixed(2);

					compareAtPrice = (Number(selectedQuantity) * Number(compareAtPriceUnit)).toFixed(2);
					discountedPrice = (compareAtPrice - totalPrice).toFixed(2);
					if (discountedPriceEle) {
						discountedPriceEle.textContent = `${discountedPrice}€`;
						limitedQuantityEle.textContent = leftQuantity;
						limitedQuantityResultPriceEle.textContent = `${enablePriceToReach}€`;
					}

					// let currency_unit = window.formatMoney(totalPrice);
					if (totalPriceValueEle && subtotalPriceLabel && unitPriceLabel) {
						console.log("These are the total price and the selected price......", totalPrice, selectedPrice);
						totalPriceValueEle.innerHTML = `${totalPrice}€`;

            if (Number(selectedQuantity) > 1) {
              subtotalPriceLabel.innerHTML = `${totalPrice}€`;
            } else {
              subtotalPriceLabel.innerHTML = `ab ${totalPrice}€`;
            }
						unitPriceLabel.innerHTML = `ab ${selectedPrice}€ p.S`;
					}

					if (!QuantitySelectorEle) return;
					QuantitySelectorEle.innerHTML = selectedQuantity;
					addToCartButtonEle.classList.add("active");
					discountTextEle.classList.add("active");
					limitedQuantityOfferEle.classList.add("active");
				});
			}

			let quantityToSlider = (qty) => {
				for (let i = 0; i < segments; i ++) {
					if (qty >= dotValues[i] && qty <= dotValues[i + 1]) {
						const fraction = (qty - dotValues[i]) / (dotValues[i + 1] - dotValues[i]);
			      return Math.round((i + fraction) * unitPerSegment);
					}
				}
				if (qty <= dotValues[0]) return 0;
				return sliderMax;
			}
			let sliderToQuantity = (sliderVal) => {
				const pos      = (sliderVal / sliderMax) * segments;
				const segIndex = Math.min(Math.floor(pos), segments - 1);
				const fraction = pos - segIndex;
				const from     = dotValues[segIndex];
				const to       = dotValues[segIndex + 1];
				return Math.round(from + (to - from) * fraction);
			}

			let positionDots = () => {
				dots.forEach((dot, i) => {
					const pct = (i / segments) * 100;
					dot.style.left = pct + '%';
				})
			}
			let updateSliderFill = (sliderVal) => {
				sliderVal = Math.max(0, Math.min(sliderMax, sliderVal));
				const qty = sliderToQuantity(sliderVal);
				const pct = (sliderVal / sliderMax) * 100;
				// const pct = ((quantity - MIN) / (MAX - MIN)) * 100;
    		slider.style.background = `linear-gradient(to right, #173586 ${pct}%, #FFF ${pct}%)`;

				const activeSeg = sliderVal / unitPerSegment;
				dots.forEach((dot, i) => {
					// dot.classList.toggle('is-passed', dotValues[i] <= quantity);
					dot.classList.toggle('is-passed', i <= activeSeg);
				});
			}
			let updateUI = (qty) => {
				qty = Math.max(MIN, Math.min(MAX, qty));

				valueEl.textContent = qty;
				slider.value = quantityToSlider(qty);
				inputEle.value = qty;

				updateSliderFill(quantityToSlider(qty));
				// trigger input change event
				const event = new Event('change', { bubbles: true });
				inputEle.dispatchEvent(event);
			}
			// Minus / Plus buttons
			minusBtn.addEventListener('click', (e) => {
				e.preventDefault();
				const newQty = Math.max(0, parseInt(valueEl.textContent) - 1);
				updateUI(newQty);
			});

			plusBtn.addEventListener('click', (e) => {
				e.preventDefault();
				const newQty = Math.max(0, parseInt(valueEl.textContent) + 1);
				updateUI(newQty);
			});

			// Slider
			slider.addEventListener('input', () => {
				updateUI( sliderToQuantity( parseInt(slider.value) ) );
				console.log("This is the slider value", slider.value);
			});

			let updateVariantUrl = () => {
				let connectLinkFunc = () => {
					let targetLinkStr = "https://tassenexpress.store/apps/zakeke?pid=8172823511290&handle=tassen-mit-logo-bedrucken-keramik&quantity=250&locale=de";
					const targetURL = new URL(targetLinkStr);
	
					let variantId = '';
					if (variantPickerEle && variantPickerEle.getAttribute("form")) {
						const formEle = document.forms[variantPickerEle.getAttribute("form")];
						if (formEle && formEle.id) {
							variantId = formEle.id.value ? formEle.id.value : '';
						}
					}
					targetURL.searchParams.set('id', variantId);
					// targetURL.searchParams.set('variant', variantId);
					targetURL.searchParams.set('quantity', selectedQuantity);
					// addToCartButtonEle.classList.add("active");

          console.log(targetURL.toString());
					window.location.href = targetURL.toString();
				}

				if (addToCartButtonEle) {
					addToCartButtonEle.addEventListener("click", (e) => {
						connectLinkFunc();
					});
				}

				if (addToCartButtonEle1) {
					addToCartButtonEle1.addEventListener("click", (e) => {
						connectLinkFunc();
					});
				}
			}

			positionDots();
			updateVariantUrl();
			
      // initiate the quantity and the price
      // const popupOverlay = document.querySelector(".pdp-group-buy-popup-overlay");

      // if (popupOverlay) {
      //   popupOverlay.classList.add("is-open");
      //   popupOverlay.classList.add("not-visible");

      //   setTimeout(() => {
      //     const slider = document.querySelector(".gbpo-quantity-selector-slider");
 
      //     if (slider) {
      //       slider.value = 100;
      //       slider.dispatchEvent(new Event("input", { bubbles: true }));
      //       slider.dispatchEvent(new Event("change", { bubbles: true }));
      //     }

      //     setTimeout(() => {
      //       popupOverlay.classList.remove("is-open");
      //       popupOverlay.classList.remove("not-visible");
      //     }, 100);
      //   }, 200);
      // }
		}
		return {
			init: initialize
		}
	})();

  let App = (() => {
    let initialize = () => {
			BDTabContainerApp.init();
			FAQApp.init();
      variantPickerApp.init();
      pdpAsLandingSliderApp.init();
      
    }
    return {
      init: initialize
    }
  })();
  
  document.addEventListener('DOMContentLoaded', () => {
    App.init();
  });
})();